import { render, staticRenderFns } from "./d-follow-tip.vue?vue&type=template&id=47fbb806&scoped=true&"
import script from "./d-follow-tip.vue?vue&type=script&lang=js&"
export * from "./d-follow-tip.vue?vue&type=script&lang=js&"
import style0 from "./d-follow-tip.vue?vue&type=style&index=0&id=47fbb806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fbb806",
  null
  
)

export default component.exports